import { CommonModule } from '@angular/common';
import {
  booleanAttribute,
  Component,
  computed,
  forwardRef,
  input,
  model,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

declare const daum: any;

export interface DaumAddress {
  address: string;
  addressEnglish: string;
  addressType: string;
  apartment: string;
  autoJibunAddress: string;
  autoJibunAddressEnglish: string;
  autoRoadAddress: string;
  autoRoadAddressEnglish: string;
  bcode: string;
  bname: string;
  bname1: string;
  bname1English: string;
  bname2: string;
  bname2English: string;
  bnameEnglish: string;
  buildingCode: string;
  buildingName: string;
  hname: string;
  jibunAddress: string;
  jibunAddressEnglish: string;
  noSelected: string;
  postcode: string;
  postcode1: string;
  postcode2: string;
  postcodeSeq: string;
  query: string;
  roadAddress: string;
  roadAddressEnglish: string;
  roadname: string;
  roadnameCode: string;
  roadnameEnglish: string;
  sido: string;
  sidoEnglish: string;
  sigungu: string;
  sigunguCode: string;
  sigunguEnglish: string;
  userLanguageType: string;
  userSelectedType: string;
  zonecode: string;
}

@Component({
  selector: 'app-input-address',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './input-address.component.html',
  styleUrls: ['./input-address.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputAddress),
      multi: true,
    },
  ],
})
export class InputAddress implements ControlValueAccessor {
  value = model('');

  async handleAddress(ev?: Event) {
    ev?.stopPropagation();
    ev?.preventDefault();
    new daum.Postcode({
      oncomplete: (data: DaumAddress) => {
        const address = data.jibunAddress
          ? data.jibunAddress
          : data.autoJibunAddress;
        this.writeValue(address);
        this.onChange(address);
      },
      width: '100%',
      height: '100%',
    }).open({
      popupName: 'daumpostcode',
    });
  }

  enableCoordinate = input<boolean, string>(false, {
    transform: booleanAttribute,
  });
  lat = model<number | null>(null);
  lng = model<number | null>(null);

  writeValue(value: string) {
    this.value.set(value);
  }
  onChange = (value: string) => {};
  onTouched = () => {};
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {}
}
